import { render, staticRenderFns } from "./Allylist.vue?vue&type=template&id=50df8e1a&scoped=true"
import script from "./Allylist.vue?vue&type=script&lang=js"
export * from "./Allylist.vue?vue&type=script&lang=js"
import style0 from "./Allylist.vue?vue&type=style&index=0&id=50df8e1a&prod&lang=css"
import style1 from "./Allylist.vue?vue&type=style&index=1&id=50df8e1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50df8e1a",
  null
  
)

export default component.exports